/* REQUEST REDUCER */

export const initialRequestState = {
  url: '',
  method: 'GET',
  body: {},
  enabled: true,
};

export const requestActions = {
  ENABLE_REQUEST: 'ENABLE_REQUEST',
  DISABLE_REQUEST: 'DISABLE_REQUEST',
};

export const requestReducer = (state, action) => {
  switch (action.type) {
    case requestActions.ENABLE_REQUEST: {
      const { url, method, body } = action.payload;
      return {
        url,
        method,
        ...(body && { body }),
        enabled: true,
      };
    }
    case requestActions.DISABLE_REQUEST:
      return initialRequestState;
    default:
      return state;
  }
};

/* MESSAGE MODAL REDUCER */

export const initialMessageModalState = {
  showModal: false,
  group: {},
  type: '',
  title: '',
  description: '',
  waring: '',
  cta: 'Remove',
};

export const messageModalActions = {
  OPEN_ARCHIVE_MESSAGE_MODAL: 'OPEN_ARCHIVE_MESSAGE_MODAL',
  OPEN_UNARCHIVE_MESSAGE_MODAL: 'OPEN_UNARCHIVE_MESSAGE_MODAL',
  OPEN_DELETE_MESSAGE_MODAL: 'OPEN_DELETE_MESSAGE_MODAL',
  OPEN_DELETE_ACTIVE_GROUP_MESSAGE_MODAL:
    'OPEN_DELETE_ACTIVE_GROUP_MESSAGE_MODAL',
  OPEN_DELETE_ARCHIVE_GROUP_MESSAGE_MODAL:
    'OPEN_DELETE_ARCHIVE_GROUP_MESSAGE_MODAL',
  CLOSE_MESSAGE_MODAL: 'CLOSE_MESSAGE_MODAL',
};

export const messageModalTypes = {
  ARCHIVE: 'ARCHIVE',
  UNARCHIVE: 'UNARCHIVE',
  DELETE: 'DELETE',
  DELETE_ACTIVE_GROUP: 'DELETE_ACTIVE_GROUP',
  DELETE_ARCHIVE_GROUP: 'DELETE_ARCHIVE_GROUP',
};

export const messageModalReducer = (state, action) => {
  if (action.type === messageModalActions.OPEN_ARCHIVE_MESSAGE_MODAL) {
    const { group } = action.payload;
    return {
      showModal: true,
      group,
      type: messageModalTypes.ARCHIVE,
      title: 'Archive Group',
      description:
        'You can archive this group to freeze the ability to approve orders. Pending orders won’t be affected.',
      cta: 'Archive Group',
    };
  }

  if (action.type === messageModalActions.OPEN_UNARCHIVE_MESSAGE_MODAL) {
    const { group } = action.payload;
    return {
      showModal: true,
      group,
      type: messageModalTypes.UNARCHIVE,
      title: 'Are you sure you would like to unarchive this group?',
      description: '',
      cta: 'Unarchive',
    };
  }

  if (action.type === messageModalActions.OPEN_DELETE_MESSAGE_MODAL) {
    const { group } = action.payload;
    return {
      showModal: true,
      group,
      type: messageModalTypes.DELETE,
      title: `Are you sure you would like to permanently delete ‘${group.name}’?`,
      description:
        'The account administrator will receive all approval requests for users not assigned to a group.',
      warning: 'Deleted groups cannot be restored.',
      cta: 'Delete',
    };
  }

  if (
    action.type === messageModalActions.OPEN_DELETE_ACTIVE_GROUP_MESSAGE_MODAL
  ) {
    const { group } = action.payload;
    return {
      showModal: true,
      group,
      type: messageModalTypes.DELETE_ACTIVE_GROUP,
      title: `‘${group.name}’ cannot be deleted`,
      description:
        'This group cannot be permanently deleted because it is linked to orders.',
      warning:
        'You can archive this group to freeze the ability to approve orders. Pending orders won’t be affected.',
      cta: 'Archive Group',
    };
  }

  if (
    action.type === messageModalActions.OPEN_DELETE_ARCHIVE_GROUP_MESSAGE_MODAL
  ) {
    const { group } = action.payload;
    return {
      showModal: true,
      group,
      type: messageModalTypes.DELETE_ARCHIVE_GROUP,
      title: `‘${group.name}’ cannot be deleted`,
      description:
        'This group cannot be permanently deleted because it is linked to orders.',
      warning: '',
      cta: '',
    };
  }

  if (action.type === messageModalActions.CLOSE_MESSAGE_MODAL) {
    return initialMessageModalState;
  }

  return state;
};

/* TABLE REDUCER */

export const initialTableState = {
  groups: [],
  groupCount: 0,
  page: 1,
  perPage: 0,
  totalPageCount: 1,
  totalGroupCount: 0,
  statusList: [],
  filter: {
    name: '',
    status: 'active',
  },
  sort: {
    type: '',
    order: 'asc',
  },
};

export const tableActions = {
  SET_GROUPS: 'SET_GROUPS',
  PAGE_CHANGE: 'PAGE_CHANGE',
  FILTER_GROUPS: 'FILTER_GROUPS',
  SORT_GROUPS: 'SORT_GROUPS',
};

export const tableReducer = (state, action) => {
  switch (action.type) {
    case tableActions.SET_GROUPS: {
      const {
        groups,
        groupCount,
        page,
        perPage,
        totalPageCount,
        totalGroupCount,
        statusList,
      } = action.payload;
      return {
        ...state,
        groups,
        groupCount,
        page,
        perPage,
        totalPageCount,
        totalGroupCount,
        statusList,
      };
    }
    case tableActions.PAGE_CHANGE:
      return {
        ...state,
        page: action.payload,
      };
    case tableActions.FILTER_GROUPS: {
      return {
        ...state,
        filter: action.payload,
      };
    }
    case tableActions.SORT_GROUPS:
      return {
        ...state,
        sort: action.payload,
      };
    default:
      return state;
  }
};
